import { KnowledgeTag } from './knowledge-tag.model';

/* ------------------------------------------------------------------ */
/*  DTOs — transport-layer shapes matching the backend JSON contracts  */
/* ------------------------------------------------------------------ */

export interface KnowledgeTagDTO {
  tag_id: string;
  tag_name: string;
  tag_key: string;
  description?: string | null;
  usage_count: number;
  created_at: string;
  client_id?: string;
  project_id?: string | null;
}

export interface KnowledgeTagListDTO {
  items: KnowledgeTagDTO[];
  total: number;
}

export interface CreateKnowledgeTagDTO {
  project_id?: string | null;
  tag_name: string;
  description?: string | null;
}

export interface AssignKnowledgeCardTagsDTO {
  tags: string[];
}

/* ------------------------------------------------------------------ */
/*  Mappers                                                            */
/* ------------------------------------------------------------------ */

/** Map a single KnowledgeTagDTO into a KnowledgeTag domain object. */
export const mapKnowledgeTagDTO = (dto: KnowledgeTagDTO, clientId?: string): KnowledgeTag => {
  return new KnowledgeTag(
    dto.tag_id,
    dto.client_id ?? clientId ?? '',
    dto.project_id ?? null,
    dto.tag_name,
    dto.tag_key,
    dto.description ?? null,
    dto.usage_count,
    dto.created_at,
  );
};

/** Map an array of KnowledgeTagDTOs into KnowledgeTag domain objects. */
export const mapKnowledgeTagListDTO = (
  dtos: KnowledgeTagDTO[],
  clientId?: string,
): KnowledgeTag[] => {
  return dtos.map((dto) => mapKnowledgeTagDTO(dto, clientId));
};
